@if (hasShadow$ | async) {
  <div class="shadow"></div>
}
@if (
  {
    authorized: isAuthenticated$ | async,
    isPresentation: isPresentationMode$ | async,
  };
  as data
) {
  <!-- has-dialog: reading the open-dialog count here repaints the route tree on every dialog open/close (WAP-1718) -->
  <div
    class="wrapper h-100"
    [class.bare-layout]="bareLayout"
    [class.has-dialog]="dialogs.openCount() > 0"
  >
    @if (data.authorized && !hideHeader) {
      <app-header> </app-header>
    }
    @if (storeService.isLoading$ | async) {
      <app-progress-bar class="position-absolute w-100"></app-progress-bar>
    }
    <div class="content" [ngClass]="{ logged: isAuthenticated$ | async }">
      <app-banner-container></app-banner-container>
      <div class="pane-container">
        @if (data.authorized && !hideHeader) {
          <app-main-menu></app-main-menu>
        }
        <router-outlet></router-outlet>
      </div>
      <ng-toast></ng-toast>
    </div>
    @if (userAccessLevel >= UserAccessLevel.GLOBAL_ADMIN) {
      <app-release-notes> </app-release-notes>
    }
  </div>
}
